import { render, staticRenderFns } from "./plateInStock.vue?vue&type=template&id=67dad3f3"
import script from "./plateInStock.vue?vue&type=script&lang=js"
export * from "./plateInStock.vue?vue&type=script&lang=js"
import style0 from "./plateInStock.vue?vue&type=style&index=0&id=67dad3f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports